document.addEventListener('DOMContentLoaded', () => {
  const messageHTML = `
    <div style="margin:20px 0;padding:16px;background:#fff8e1;border:1px solid #ffeb3b;border-radius:8px;font-size:14px;line-height:1.5;color:#333;">
      The email address you provided is not currently in our authorized dealer database.<br>
      If you’re an approved dealer or believe this is an error, please contact our team at
      <a href="mailto:sales@enbeck.com" style="color:#111827;text-decoration:underline;">sales@enbeck.com</a>
      so we can verify and assist you.
    </div>
  `;

  const addMessage = () => {
    // CHANGE 1: Check globally first (this is what kills duplicates 100%)
    if (document.querySelector('.my-custom-dealer-message')) return;

    const container = document.querySelector('#login > div.rgstrrgtcol.form-page.cad-scrollable.active[data-user-form="register"]');
    
    if (container) {
      // CHANGE 2: Include the class directly in the inserted HTML
      container.insertAdjacentHTML('afterbegin', 
        `<div class="my-custom-dealer-message">${messageHTML}</div>`
      );

      // CHANGE 3: Stop the interval immediately
      clearInterval(interval);
    }
  };

  addMessage();

  // Safe polling — will stop the moment the message is added
  const interval = setInterval(addMessage, 500);
  
  // Safety net: stop checking after 15 seconds
  setTimeout(() => clearInterval(interval), 15000);

  const selectCanadaSilently = () => {
    // Target all SureCust country dropdowns (they all have width: 105px inline)
    const selects = document.querySelectorAll('select[style*="105px"]');

    let foundAndChanged = false;

    selects.forEach(select => {
      const canadaOption = Array.from(select.options).find(opt =>
        opt.textContent.includes('🇨🇦 (+1)') || opt.textContent.includes('(🇨🇦 (+1))')
      );

      if (canadaOption && !canadaOption.selected) {
        canadaOption.selected = true;   // ← silent change only
        foundAndChanged = true;

        // OPTIONAL: if you later notice the phone prefix doesn't update,
        // uncomment ONE of these lines (test one at a time):
        // select.dispatchEvent(new Event('input',  { bubbles: true }));
        // select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    return foundAndChanged;
  };

  // Try immediately + retry for 10 seconds
  if (!selectCanadaSilently()) {
    let attempts = 0;
    const checker = setInterval(() => {
      if (selectCanadaSilently() || attempts++ > 40) {
        clearInterval(checker);
      }
    }, 250);
  }
});

